import React from 'react';

const BookOpenSvg = (props) => (
    <svg
        className="book-open_svg__eds-icon--book-open_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="book-open_svg__eds-icon--book-open_base"
            d="M3 3.8v14.4h5.6c1.3 0 2.4.8 2.8 2h1c.4-1.2 1.5-2 2.8-2H21V3.8H3zm8.5 14.6c-.7-.8-1.7-1.3-2.9-1.3H4V4.8h7.5v13.6zm8.5-1.2h-4.6c-1.1 0-2.1.5-2.9 1.3V4.8H20v12.4z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line_5_"
            d="M6 14.1h4v1H6z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line_4_"
            d="M6 11h4v1H6z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line_3_"
            d="M6 7.9h4v1H6z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line_2_"
            d="M14 14.1h4v1h-4z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line_1_"
            d="M14 11h4v1h-4z"
        />
        <path
            className="book-open_svg__eds-icon--book-open_line"
            d="M14 7.9h4v1h-4z"
        />
    </svg>
);

BookOpenSvg.displayName = 'BookOpenSvg';
export default BookOpenSvg;
